import { useEffect } from 'react';

import { selectMetadataFillingJobsSignatureByObjectId } from '@iconik-io/shared-lib/src/redux/selectors/jobs/selectors';

import {
  useAppDispatch,
  useAppSelector,
} from '../../../store/react_redux_typed';
import { reconcileAiMetadataProposal } from '../thunks';

/**
 * Keeps the local AI-metadata generation for the asset version in sync with the
 * server's proposal state, in realtime and across tabs. Re-runs on mount, on
 * version change, and whenever this asset's METADATA_FILLING jobs change status
 * (the websocket keeps those fresh per tab), so the metadata-panel button
 * reflects a proposal appearing or being accepted/discarded in any tab.
 */
export function useReconcileAiMetadataProposal(
  assetId: string,
  versionId: string | undefined,
) {
  const dispatch = useAppDispatch();
  const jobsSignature = useAppSelector((state) =>
    selectMetadataFillingJobsSignatureByObjectId(state, assetId),
  );

  // jobsSignature is a trigger — not read in the body, but a change to it (a
  // metadata-filling job appearing or changing status) must re-run reconcile.
  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional trigger dependency
  useEffect(() => {
    if (!assetId || !versionId) {
      return;
    }
    dispatch(reconcileAiMetadataProposal(assetId, versionId));
  }, [assetId, versionId, jobsSignature]);
}
